export const BUSINESS = {
  name: "Savannah's House",
  tagline: "A Safe Place to Call Home. A Family You Can Trust.",
  statement: "We don’t just provide a place to stay. We create a place to belong.",
  city: "Tyler, Texas",
  serviceArea: "Tyler, Texas & the surrounding East Texas community",
  phone: "(903) 202-4950",
  phoneHref: "tel:+19032024950",
  email: "info@savannahshouse.org",
  emailHref: "mailto:info@savannahshouse.org",
  hours: "Monday–Friday, 9:00 AM–5:00 PM",
  facebook: "https://www.facebook.com/profile.php?id=61594235575681",
  copyright: "© 2026 Savannah’s House / Key Suites and Designs LLC. All Rights Reserved.",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Senior Living", to: "/senior-living" },
  { label: "Veterans", to: "/veteran-housing" },
  { label: "Rooms & Pricing", to: "/rooms-pricing" },
  { label: "Life at Savannah’s House", to: "/life-at-savannahs-house" },
  { label: "FAQ", to: "/faq" },
  { label: "Referral Partners", to: "/referral-partners" },
  { label: "Waiting List", to: "/waiting-list" },
  { label: "Resident Inquiry", to: "/resident-inquiry" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const img = (name, w = 1600) => `/images/${name}-${w}.webp`;

export const srcSet = (name) =>
  `${img(name, 480)} 480w, ${img(name, 900)} 900w, ${img(name, 1600)} 1600w`;

export const DIMS = {
  armchair: [1600, 2134],
  bathroom: [1600, 1068],
  bedroom: [1600, 1600],
  bedroom2: [1600, 1067],
  bedroom3: [1600, 960],
  dining: [1600, 900],
  exterior: [1600, 1067],
  field: [1600, 900],
  garden: [1600, 1067],
  hands: [1600, 1067],
  kitchen: [1600, 960],
  living1: [1600, 1067],
  living2: [1600, 1067],
  living3: [1600, 1067],
  seniorcouple: [1600, 1896],
};

export const GALLERY = [
  { name: "exterior", title: "Home Exterior", alt: "Warmly lit residential home exterior at dusk with welcoming front entrance" },
  { name: "living1", title: "Living Room", alt: "Comfortable living room with soft seating, natural light, and warm wood beams" },
  { name: "bedroom", title: "Private Bedroom", alt: "Bright, comfortably furnished private bedroom with soft neutral bedding" },
  { name: "bedroom2", title: "Bedroom Suite", alt: "Peaceful bedroom with natural light and tasteful residential furnishings" },
  { name: "bedroom3", title: "Guest Room", alt: "Cozy bedroom retreat with layered bedding and warm accent lighting" },
  { name: "dining", title: "Dining Area", alt: "Inviting dining area set for shared meals in a residential home" },
  { name: "kitchen", title: "Kitchen", alt: "Warm, functional home kitchen with natural wood cabinetry" },
  { name: "bathroom", title: "Bathroom", alt: "Clean, bright residential bathroom with modern accessible features" },
  { name: "garden", title: "Outdoor Spaces", alt: "Welcoming home exterior with a well-kept front lawn and walkway" },
  { name: "armchair", title: "A Quiet Corner", alt: "Comfortable armchair in soft sunlight, a quiet place to relax" },
  { name: "living2", title: "Common Area", alt: "Welcoming shared living space with comfortable seating" },
  { name: "living3", title: "Sitting Room", alt: "Relaxed sitting area with sofa and natural textures" },
];

export const FAQ_ITEMS = [
  {
    q: "Who does Savannah’s House serve?",
    a: "We primarily serve seniors, veterans, adults with disabilities, and individuals seeking a safe and supportive residential environment.",
  },
  {
    q: "How many residents will live in the home?",
    a: "Savannah’s House is designed as a small residential setting with approximately 4–6 residents.",
  },
  {
    q: "Do you provide meals?",
    a: "Yes. Meals are included as part of the residential experience.",
  },
  {
    q: "Do you provide transportation?",
    a: "Transportation assistance may be available for appropriate appointments, errands, and activities.",
  },
  {
    q: "Do you provide medical care?",
    a: "Savannah’s House is designed to provide supportive, non-medical residential services. Medical or skilled healthcare needs should be addressed by appropriately licensed healthcare professionals.",
  },
  {
    q: "Do you offer private rooms?",
    a: "Yes. Private rooms may be available depending on occupancy.",
  },
  {
    q: "Do you offer shared rooms?",
    a: "Yes. Shared/semi-private accommodations may be available.",
  },
  {
    q: "How much does it cost?",
    a: "Contact us for current pricing and room availability.",
  },
  {
    q: "Is Savannah’s House private pay?",
    a: "Yes. At this time, Savannah’s House is private pay. Contact us to discuss current pricing, room availability, and payment details.",
  },
  {
    q: "Can families tour the home?",
    a: "Yes. Prospective residents and families are encouraged to contact us to discuss scheduling a tour.",
  },
  {
    q: "Do you accept veterans?",
    a: "Yes. Savannah’s House welcomes veterans.",
  },
  {
    q: "How do I begin the admission process?",
    a: "Contact us to discuss availability, resident needs, room options, pricing, and the next steps.",
  },
];
